import { AxiosInstance } from 'axios';
import { simulate } from './utils';
import { InfluencerToken, InfluencerTokenRequest } from 'referral-types';

export const baseEndpoint = 'influencer-token';

export class InfluencerTokenApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async create(formValues: InfluencerTokenRequest): Promise<InfluencerToken> {
    await simulate();
    const response = await this.apiInstance.post(`/create`, formValues);

    return response.data; 
  }
}
